import { css } from '@emotion/react';

import * as theme from '../theme';

export const fontSans = css({
	fontFamily: theme.fontFamily.sans,
});

export const fontSerif = css({
	fontFamily: theme.fontFamily.serif,
});

export const fontMono = css({
	fontFamily: theme.fontFamily.mono,
});

export const fontInputHelper = css({
	fontFamily: theme.fontFamily.inputHelper,
});
